/**
 * MessagesSection (UNE Messages Tab — Fase 1)
 * Historico de push notifications al cliente en el expediente.
 * Clasificacion por keyword (server-side), chips correlacionales ±48h,
 * filtro default "Solo credito", paginacion cursor.
 */
import { Button } from '@/components/ui/Button';
import { useExpedienteMessages } from '../../hooks';
import { MessageFilters } from './MessageFilters';
import { MessageRow } from './MessageRow';

interface Props {
  directoryId: string;
}

export function MessagesSection({ directoryId }: Props) {
  const {
    items,
    hasNext,
    loadNext,
    filters,
    setFilters,
    isLoading,
    isError,
  } = useExpedienteMessages(directoryId, true);

  // Estado de carga
  if (isLoading) {
    return <div className="p-4 text-sm text-muted-foreground">Cargando mensajes…</div>;
  }

  // Estado de error
  if (isError) {
    return <div className="p-4 text-sm text-red-600 dark:text-red-400">Error al cargar mensajes.</div>;
  }

  return (
    <div>
      {/* Barra de filtros */}
      <MessageFilters filters={filters} onChange={setFilters} />

      {items.length === 0 ? (
        /* Estado vacío con guia contextual */
        <div className="p-6 text-sm text-muted-foreground text-center">
          {filters.category === 'credit'
            ? 'Este cliente no tiene mensajes de crédito en el rango actual. Desmarca "Solo crédito" para incluir mensajes de wallet.'
            : 'Sin mensajes registrados.'}
        </div>
      ) : (
        <>
          {/* Lista de filas expandibles */}
          <div className="overflow-hidden rounded-md border border-border mx-4 mt-3">
            {items.map(entry => (
              <MessageRow key={entry.id} entry={entry} />
            ))}
          </div>

          {/* Paginacion cursor: mostrar solo si hay mas resultados */}
          {hasNext && (
            <div className="p-3 text-center">
              <Button variant="ghost" size="sm" onClick={loadNext}>
                Cargar más
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
